import { DialogsModule } from '@progress/kendo-angular-dialog';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { CoreModule } from '@core/core.module';
import { LoaderModule } from '@core/loader/loader.module';
import { BannerNotificationModule } from '@core/notification-banner/notification-banner.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { SharedModule } from '@shared/shared.module';
import { AngularSplitModule } from 'angular-split';
import { AccountTreeComponent } from './account-tree/account-tree.component';
import { BalanceSheetComponent } from './balance-sheet.component';
import { InputStructureComponent } from './input-structure/input-structure.component';
import { UnusedAccountsComponent } from './unused-accounts/unused-accounts.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { ToastrModule } from 'ngx-toastr'

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    SpreadSheetsModule,
    MatIconModule,
    MatTreeModule,
    HttpClientModule,
    AngularSplitModule,
    LoaderModule,
    ToastrModule,
    BannerNotificationModule,
    ButtonsModule,
    DialogsModule,
  ],
  declarations: [BalanceSheetComponent, AccountTreeComponent, InputStructureComponent, UnusedAccountsComponent],
  exports: [RouterModule],
})
export class BalanceSheetModule {}
